module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "spinner spinner--cube-shadow",
    style: (_vm.styles)
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-99c0fdb6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-loading-spinner/src/components/CubeShadow.vue
// module id = 757
// module chunks = 0